

















































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import ajax from '@/lib/ajax';

interface BusinessUnitSummary {
    reference: string;
    name: string;
}

interface BusinessUnitStatus {
    reference: string;
    name: string;
    error?: string;
    pendingTimesheets: number;
    processedWorkerCount: number;
    unprocessedWorkerCount: number;
    expectedPaidTotal: number;
    paidTotal: number;
}


@Component({
    name: 'PureProTestPanel',
})
export default class extends GiganautVue {
    pingLoading = false;
    pingOk = false;
    pingError = '';

    busLoading = false;
    businessUnits: BusinessUnitSummary[] | null = null;
    busError = '';

    statusLoading = false;
    businessUnitStatuses: BusinessUnitStatus[] | null = null;
    statusError = '';

    async onPing() {
        this.pingLoading = true;
        this.pingOk = false;
        this.pingError = '';
        try {
            await ajax.post('/api/v1/agency/integrations/pure-pro/ping', {});
            this.pingOk = true;
        } catch (e: any) {
            // Backend returns parsed PurePro ProblemDetails for upstream
            // errors; e.response?.data?.message is the formatted string.
            this.pingError = this.extractError(e) || 'Connection failed';
        } finally {
            this.pingLoading = false;
        }
    }

    async onListBusinessUnits() {
        this.busLoading = true;
        this.businessUnits = null;
        this.busError = '';
        try {
            const response = await ajax.get('/api/v1/agency/integrations/pure-pro/business-units');
            this.businessUnits = response.data || [];
        } catch (e: any) {
            this.busError = this.extractError(e) || 'Failed to list business units';
        } finally {
            this.busLoading = false;
        }
    }

    async onListBusinessUnitStatuses() {
        this.statusLoading = true;
        this.businessUnitStatuses = null;
        this.statusError = '';
        try {
            const response = await ajax.get('/api/v1/agency/payroll/pure-pro/business-unit-statuses');
            this.businessUnitStatuses = response.data || [];
        } catch (e: any) {
            this.statusError = this.extractError(e) || 'Failed to load business unit statuses';
        } finally {
            this.statusLoading = false;
        }
    }

    // PurePro totals arrive as integers — treated as pence (unverified in
    // the swagger; flip here if the sandbox proves otherwise).
    formatPence(p: number): string {
        if (!p) return '£0.00';
        return '£' + (p / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    extractError(e: any): string {
        if (!e) return '';
        if (e.response && e.response.data && e.response.data.message) return e.response.data.message;
        if (e.message) return e.message;
        return '';
    }
}
